const pathBase = `/system/member_profile_statistics/`;

export const memberProfileStatistics = {
  get: () => pathBase,
};
